export default __webpack_public_path__ + "static/media/layout-3.ab7913ef.jpg";